import { render, staticRenderFns } from "./DisablePromoCodeLoader.vue?vue&type=template&id=81df6fa0"
import script from "./DisablePromoCodeLoader.vue?vue&type=script&lang=ts"
export * from "./DisablePromoCodeLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports